import { AxiosResponse } from 'axios';

import { apiClient } from '~/services/api-service';

export const filesAPIService = {
  uploadImage: (filepond: FormData): Promise<AxiosResponse<string>> => {
    return apiClient.post('/filehub/process/', { filepond }, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};
